import React from 'react';
// @ts-ignore
import './Card.scss';

export default function ContactPerson({image, name, company, quali, email}) {
    return (
        <div className="ContactPerson">
            <img className="ImagePerson" src={image} alt={name}/>
            <div className="NamePerson">{name}</div>
            <div className="Company">{company}</div>
            <div className="QualificationsContactPerson">{quali}</div>
            <div className="EmailContactPerson">
                <a className="EmailLink" href={"mailto:"+email}>{email}</a>
            </div>
        </div>
    )
}